import * as s from "styles/ModalCommonStyled";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import BigButton from "components/atoms/buttons/BigButton";
import EmailEditor from "components/atoms/input/editor/EmailEditor";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import SelectComponent from "components/atoms/select/SelectComponent";
import { Option, recipentsOptions } from "utils/options";
import styled from "styled-components";

import { AddEmail } from "api/interfaces/emailInterface.interface";
import { ValidateWord } from "components/atoms/text/Text";
import {
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import InputDate from "components/atoms/calendar/InputDate";

export enum UPDATE_TYPE {
  SUBJECT,
  MESSAGE,
  EMAIL_TYPE,
  SCHEDULE_TIME,
  USERS,
}
interface Props {
  state: AddEmail;
  users: Option[];
  usersIsFetching: boolean;
  isEdit?: boolean;
  onModal: (type?: string) => void;
  onClickSend: (isSchedule?: boolean) => void;
  onChange: (type: UPDATE_TYPE, value: any) => void;
  onChangeMessage: (value: string) => void;
  onChangeTime: (value: string) => void;
  validate: ValidateMsg;
}
export function AddModalPresenter(props: Props): JSX.Element {
  const { onModal, onClickSend, onChange, onChangeMessage, onChangeTime } =
    props;

  return (
    <BigPopupTemplate
      title={props.isEdit ? "Edit an Email" : "Write an Email"}
      onModal={onModal}
    >
      <s.Row>
        <ModalInput label="Recipients" essential>
          <SelectComponent
            options={recipentsOptions}
            onChange={(value) => onChange(UPDATE_TYPE.EMAIL_TYPE, value)}
            value={props.state.recipientType}
            data-testid="manager-email-add-selects-change"
          />
        </ModalInput>
        <ModalInput
          label="Send Date / Time"
          validatedWord={props.validate.scheduleTime}
          isValidated={!!props.validate.scheduleTime}
        >
          <InputDate
            value={props.state.scheduleTime}
            onChange={(date) => onChangeTime(date as string)}
            allowTime={true}
            required
          />
        </ModalInput>
      </s.Row>
      {props.state.recipientType === "USER" && (
        <SelectComponent
          mode="multiple"
          options={props.users}
          loading={props.usersIsFetching}
          value={(props.state.users || []).map((u) => u.email)}
          onChange={(value) => onChange(UPDATE_TYPE.USERS, value)}
        />
      )}

      {props.validate.user !== "" && (
        <s.Row>
          <ValidateWord data-testid="manager-email-add-validate-user">
            {props.validate.user}
          </ValidateWord>
        </s.Row>
      )}

      <ModalInput
        label="Subject"
        essential
        validatedWord={props.validate.title}
        isValidated={!!props.validate.title}
      >
        <Input
          value={props.state.subject}
          placeholder="Enter Subject"
          onChange={(e) => onChange(UPDATE_TYPE.SUBJECT, e.target.value)}
          data-testid="manager-email-add-input-change"
        />
      </ModalInput>
      <ModalInput
        label="Message"
        essential
        validatedWord={props.validate.message}
        isValidated={!!props.validate.message}
      >
        <EmailEditor
          value={props.state.message}
          placeholder="Please enter a message."
          onChange={onChangeMessage}
        />
      </ModalInput>
      <s.ButtonWrapper>
        <BigButton
          buttonType="cancel"
          label="Send Now"
          onClickBtn={() => onClickSend()}
          data-testid="manager-email-add-button-click-send"
        />

        <BigButton
          label="Schedule Email"
          onClickBtn={() => onClickSend(true)}
          data-testid="manager-email-add-button-click-send-2"
        />
      </s.ButtonWrapper>
    </BigPopupTemplate>
  );
}

const DateTimeSelectWrapper = styled.div`
  width: 100%;
`;
